import React from 'react';

import classes from './RatingStars.module.scss';

const GOLD = '#F0AC0B';
const GRAY = '#E0E0E0';

const StarIcon = ({ size, color, className }) => (
	<svg
		className={className}
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill={color}
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
			fill={color}
			stroke={color}
			strokeWidth="2.8"
			strokeLinejoin="round"
			strokeLinecap="round"
		/>
	</svg>
);

/**
 * Reusable star rating display.
 * Renders `count` stars where the gold fill follows `value`, supporting partial
 * stars (e.g. 4.5, 3.2). By default the value is snapped to the nearest half so
 * decimals render as a half gold star; pass rounding="exact" to fill precisely.
 */
const RatingStars = ({ value = 0, count = 5, size = 18, gap = 2, rounding = 'half' }) => {
	const safeValue = Math.max(0, Math.min(count, Number(value) || 0));
	const displayValue = rounding === 'exact' ? safeValue : Math.round(safeValue * 2) / 2;

	return (
		<span className={classes['stars']} style={{ gap }}>
			{Array.from({ length: count }, (_, index) => {
				const fill = Math.max(0, Math.min(1, displayValue - index));
				return (
					<span
						key={index}
						className={classes['star']}
						style={{ width: size, height: size }}>
						<StarIcon className={classes['base']} size={size} color={GRAY} />
						{fill > 0 && (
							<span className={classes['overlay']} style={{ width: `${fill * 100}%` }}>
								<span className={classes['overlay-inner']} style={{ width: size, height: size }}>
									<StarIcon size={size} color={GOLD} />
								</span>
							</span>
						)}
					</span>
				);
			})}
		</span>
	);
};

export default RatingStars;
